(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfo-blog"] && !Shopify.designMode) return;
  try {
    
  const navigationRoot = document.querySelector('.nfo-insights-header');
  if (navigationRoot && navigationRoot.dataset.dropdownReady !== 'true') {
    navigationRoot.dataset.dropdownReady = 'true';
    const dropdowns = Array.from(navigationRoot.querySelectorAll('details'));
    const mobileToggle = navigationRoot.querySelector('input[type="checkbox"]');
    const mobileButton = navigationRoot.querySelector('.nfo-insights-menu');
    const syncMobileMenu = () => mobileButton?.setAttribute('aria-expanded', mobileToggle?.checked ? 'true' : 'false');
    mobileToggle?.addEventListener('change', syncMobileMenu);
    mobileButton?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        mobileToggle.checked = !mobileToggle.checked;
        syncMobileMenu();
      }
    });
    const closeDropdowns = (exception) => {
      dropdowns.forEach((dropdown) => {
        if (dropdown !== exception) dropdown.removeAttribute('open');
      });
    };

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) closeDropdowns(dropdown);
      });
    });

    navigationRoot.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
      }
    });

    document.addEventListener('click', (event) => {
      if (!navigationRoot.contains(event.target)) {
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const openDropdown = navigationRoot.querySelector('details[open]');
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
        openDropdown?.querySelector('summary')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfo-content-page"] && !Shopify.designMode) return;
  try {
    
  const navigationRoot = document.querySelector('.nfo-page-nav-wrap');
  if (navigationRoot && navigationRoot.dataset.dropdownReady !== 'true') {
    navigationRoot.dataset.dropdownReady = 'true';
    const dropdowns = Array.from(navigationRoot.querySelectorAll('details'));
    const mobileToggle = navigationRoot.querySelector('input[type="checkbox"]');
    const mobileButton = navigationRoot.querySelector('.nfo-page-menu-button');
    const syncMobileMenu = () => mobileButton?.setAttribute('aria-expanded', mobileToggle?.checked ? 'true' : 'false');
    mobileToggle?.addEventListener('change', syncMobileMenu);
    mobileButton?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        mobileToggle.checked = !mobileToggle.checked;
        syncMobileMenu();
      }
    });
    const closeDropdowns = (exception) => {
      dropdowns.forEach((dropdown) => {
        if (dropdown !== exception) dropdown.removeAttribute('open');
      });
    };

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) closeDropdowns(dropdown);
      });
    });

    navigationRoot.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
      }
    });

    document.addEventListener('click', (event) => {
      if (!navigationRoot.contains(event.target)) {
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const openDropdown = navigationRoot.querySelector('details[open]');
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
        openDropdown?.querySelector('summary')?.focus();
      }
    });
  }
  document.querySelectorAll('form[id^="nfo-package"]').forEach((form) => {
    const targetId = form.id === 'nfo-package-purchase-form' ? 'nfo-package-price' : 'nfo-card-price-' + form.id.split('-').pop();
    const priceTarget = document.getElementById(targetId);
    form.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"]') && priceTarget) priceTarget.textContent = event.target.dataset.price;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfo-global-header"]) return;
  try {
    
(()=>{const root=document.querySelector('.nfo-global-header');if(!root||root.dataset.ready==='true')return;root.dataset.ready='true';const toggle=root.querySelector('.nfo-global-toggle'),button=root.querySelector('.nfo-global-menu-button'),drops=[...root.querySelectorAll('details')];const sync=()=>button?.setAttribute('aria-expanded',toggle?.checked?'true':'false');toggle?.addEventListener('change',sync);button?.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle.checked=!toggle.checked;toggle.dispatchEvent(new Event('change'));}});drops.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)drops.forEach(x=>{if(x!==d)x.removeAttribute('open')})}));document.addEventListener('click',e=>{if(!root.contains(e.target)){drops.forEach(d=>d.removeAttribute('open'));if(toggle){toggle.checked=false;sync()}}});document.addEventListener('keydown',e=>{if(e.key==='Escape'){drops.forEach(d=>d.removeAttribute('open'));if(toggle){toggle.checked=false;sync()}}});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nfo-homepage"] && !Shopify.designMode) return;
  try {
    
  const navigationRoot = document.querySelector('.nfo-nav-wrap');
  if (navigationRoot && navigationRoot.dataset.dropdownReady !== 'true') {
    navigationRoot.dataset.dropdownReady = 'true';
    const dropdowns = Array.from(navigationRoot.querySelectorAll('details'));
    const mobileToggle = navigationRoot.querySelector('input[type="checkbox"]');
    const mobileButton = navigationRoot.querySelector('.nfo-menu-button');
    const syncMobileMenu = () => mobileButton?.setAttribute('aria-expanded', mobileToggle?.checked ? 'true' : 'false');
    mobileToggle?.addEventListener('change', syncMobileMenu);
    mobileButton?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        mobileToggle.checked = !mobileToggle.checked;
        syncMobileMenu();
      }
    });
    const closeDropdowns = (exception) => {
      dropdowns.forEach((dropdown) => {
        if (dropdown !== exception) dropdown.removeAttribute('open');
      });
    };

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (dropdown.open) closeDropdowns(dropdown);
      });
    });

    navigationRoot.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
      }
    });

    document.addEventListener('click', (event) => {
      if (!navigationRoot.contains(event.target)) {
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const openDropdown = navigationRoot.querySelector('details[open]');
        closeDropdowns();
        if (mobileToggle) { mobileToggle.checked = false; syncMobileMenu(); }
        openDropdown?.querySelector('summary')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
